import React, { memo } from 'react';
import { Skeleton } from '@mui/material';

const LoadingPlaceholder = (options) => {
  return <Skeleton {...options} />;
};

export default memo(LoadingPlaceholder);
